import * as React from 'react';

function isUndefined(value: unknown) {
  return typeof value === 'undefined';
}

export default function useToggle({ initialValue = true } = {}): [boolean, (value?: boolean) => void] {
  return React.useReducer(
    (on: boolean, forceValue: unknown) => (!isUndefined(forceValue) ? Boolean(forceValue) : !on),
    initialValue,
  );
}
